import { TourHistoryTourStatusDto } from 'common/enums/services/api/tours/tour-status-dto.enum';

export const filterStatusTourHistoryLabel: Record<TourHistoryTourStatusDto, string> = {
  [TourHistoryTourStatusDto.Finished]: 'Finished',
  [TourHistoryTourStatusDto.Skipped]: 'Skipped',
  [TourHistoryTourStatusDto.Expired]: 'Expired',
  [TourHistoryTourStatusDto.Canceled]: 'Canceled',
  [TourHistoryTourStatusDto.Rejected]: 'Canceled by landlord',
};
